import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Badge, Tabs, Tab, Form, Button, Image, InputGroup } from "react-bootstrap";
import { Link, useNavigate, useNavigationType, useParams } from "react-router-dom";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { base64ToBlob, NumberFormatFloat, NumberFormat } from "utils/HelperFunction";
import Select, { StylesConfig } from "react-select";
import { Formik, Field, FieldArray } from "formik";
import Modal from "react-bootstrap/Modal";
import DataTableLayout from "layouts/DatatableLayout";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import * as yup from "yup";
import DownloadExcel from "utils/DownloadExcel";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { getPresentationInfoById, clearGetPresentationInfoById } from "../../redux/handlers/product/getPresentationInfoById.handler";
import { getProductInfoById, clearGetProductInfoById } from "../../redux/handlers/product/getProductInfoById.handler";
import { updateStatusProduct, clearUpdateStatusProduct } from "../../redux/handlers/product/updateStatusProduct.handler";
import { getProductType } from "../../redux/handlers/product/getProductType.handler";
import { getCategory } from "../../redux/handlers/product/getCategory.handler";
import { getSubCategory } from "../../redux/handlers/product/getSubCategory.handler";
import { createCommentProduct, clearCreateCommentProduct } from "../../redux/handlers/product/createCommentProduct.handler";
// import { getEvidenceType } from "../../redux/handlers/product/getEvidenceType.handler";
import { getAllMstUnit } from "../../redux/handlers/product/getAllMstUnit.handler";
import { getAllMstUnitWeight } from "../../redux/handlers/product/getAllMstUnitWeight.handler";
import { getAllDimension } from "../../redux/handlers/product/getAllDimension.handler";
import { getAllProductTypeFile } from "../../redux/handlers/product/getAllProductTypeFile.handler";
import { getAllMstBrand } from "../../redux/handlers/master/getAllMstBrand.handler";
import moment from "moment";
import "moment/locale/th";
import { Stack } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import CircleIcon from "@mui/icons-material/Circle";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import { Avatar } from "@mui/material";
import DownloadFile from "utils/DownloadFile";
export function ManageProductsDatalist() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(1), 2), tab = _useState[0], setTab = _useState[1];
    var _useState1 = _sliced_to_array(useState("view"), 2), mode = _useState1[0], setMode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), formdisabled = _useState2[0], setFormdisabled = _useState2[1];
    var partnerId = useParams().partnerId;
    var _useState3 = _sliced_to_array(useState({}), 2), formdata = _useState3[0], setFormdata = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), productRow = _useState4[0], setProductRow = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState5[0], setModalsuccess = _useState5[1];
    var getPresentationInfoByIdReducer = useAppSelector(function(state) {
        return state.getPresentationInfoByIdReducer;
    });
    var getData = function() {
        dispatch(getPresentationInfoById(parseInt(partnerId, 10), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(getPresentationInfoByIdReducer.isFetching);
        if (getPresentationInfoByIdReducer.data && !getPresentationInfoByIdReducer.isError) {
            var datas = getPresentationInfoByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            setFormdata(dataWithReplacements);
            setFormdisabled(true);
            if (datas && datas.PdPpresendetail && datas.PdPpresendetail.length > 0) {
                setProductRow(datas.PdPpresendetail.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        noItem: index + 1
                    });
                }));
            } else {
                setProductRow([]);
            }
        }
    }, [
        getPresentationInfoByIdReducer
    ]);
    var row = [
        {
            id: 1,
            code: "SK12651",
            barcode: "8854815084851",
            name: "น้ำตาลทรายขาว 1 KG",
            option: "น้ำตาลทรายขาว 1 KG",
            unit: "ลัง",
            rate: "1x1",
            pricePresent: "50.00",
            priceRecommended: "79.00",
            gp: "79.00",
            status: 1
        },
        {
            id: 2,
            code: "SK12652",
            barcode: "8854815084852",
            name: "น้ำตาลทรายขาว 1 KG",
            option: "น้ำตาลทรายขาว 1 KG",
            unit: "ลัง",
            rate: "1x1",
            pricePresent: "50.00",
            priceRecommended: "79.00",
            gp: "79.00",
            status: 1
        },
        {
            id: 3,
            code: "SK12653",
            barcode: "8854815084853",
            name: "น้ำตาลทรายขาว 1 KG",
            option: "น้ำตาลทรายขาว 1 KG",
            unit: "ลัง",
            rate: "1x1",
            pricePresent: "50.00",
            priceRecommended: "79.00",
            gp: "79.00",
            status: 1
        },
        {
            id: 4,
            code: "SK12654",
            barcode: "8854815084854",
            name: "น้ำตาลทรายขาว 1 KG",
            option: "น้ำตาลทรายขาว 1 KG",
            unit: "ลัง",
            rate: "1x1",
            pricePresent: "50.00",
            priceRecommended: "79.00",
            gp: "79.00",
            status: 1
        }
    ];
    var columns = [
        {
            name: "ลำดับ",
            selector: function(row) {
                return row.noItem;
            },
            width: "80px",
            center: "true"
        },
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.PdProduct.pd_product_code;
            },
            // center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_products/view/" + row.pd_ppresendetail_id,
                        children: row.PdProduct.pd_product_code ? row.PdProduct.pd_product_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "บาร์โค๊ด",
            selector: function(row) {
                return row.PdProduct.pd_product_barcode ? row.PdProduct.pd_product_barcode : "-";
            },
            center: "true",
            width: "180px"
        },
        {
            name: "ชื่อสินค้า",
            // center: "true",
            selector: function(row) {
                return row.PdProduct.pd_product_nameth ? row.PdProduct.pd_product_nameth : "-";
            }
        },
        {
            name: "หน่วย",
            center: "true",
            width: "100px",
            selector: function(row) {
                return row.PdProduct.SetUnit.set_unit_name ? row.PdProduct.SetUnit.set_unit_name : "-";
            }
        },
        {
            name: "ราคานำเสนอ",
            center: "true",
            selector: function(row) {
                return row.PdProduct.pd_product_price;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.PdProduct.pd_product_price && row.PdProduct.pd_product_price >= 0 ? NumberFormatFloat(row.PdProduct.pd_product_price, 2) : "-"
                });
            }
        },
        {
            name: "ราคาขาย",
            center: "true",
            selector: function(row) {
                return row.PdProduct.pd_product_recommentprice;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.PdProduct.pd_product_recommentprice && row.PdProduct.pd_product_recommentprice >= 0 ? NumberFormatFloat(row.PdProduct.pd_product_recommentprice, 2) : "-"
                });
            }
        },
        {
            name: "GP",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.PdProduct.pd_product_gp;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.PdProduct.pd_product_gp && row.PdProduct.pd_product_gp != "" && row.PdProduct.pd_product_gp != null && row.PdProduct.pd_product_gp != "null" ? NumberFormatFloat(row.PdProduct.pd_product_gp, 2) + " %" : "-"
                });
            }
        },
        {
            name: "วันหมดอายุ",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.PdProduct.pd_product_pddate;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.PdProduct.pd_product_pddate && row.PdProduct.pd_product_pddate != "" && row.PdProduct.pd_product_pddate != null ? moment(row.PdProduct.pd_product_pddate).format("DD/MM/YYYY") : "-"
                });
            }
        },
        {
            name: "อายุสินค้า",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.PdProduct.pd_product_dayexpire;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.PdProduct.pd_product_pddate && row.PdProduct.pd_product_pddate != "" && row.PdProduct.pd_product_pddate != null ? moment(row.PdProduct.pd_product_pddate).add({
                        days: 1
                    }).diff(moment(), "days") : "-"
                });
            }
        },
        {
            name: "สถานะ",
            center: "true",
            width: "130px",
            selector: function(row) {
                return row.pd_ppresendetail_status;
            },
            cell: function(row, index, column, id) {
                return row.pd_ppresendetail_status == 5 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6f42c1",
                        backgroundColor: "#e2d9f3",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: "รอแก้ไข"
                }) : row.pd_ppresendetail_status == 4 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(211, 47, 47, 1)",
                        backgroundColor: "rgba(253, 237, 237, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: "ไม่อนุมัติ"
                }) : row.pd_ppresendetail_status == 3 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: "อนุมัติ"
                }) : row.pd_ppresendetail_status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: "รออนุมัติ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: "แบบร่าง"
                });
            }
        },
        {
            name: "จัดการ",
            center: "true",
            selector: function(row) {
                return row.pd_ppresendetail_id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Link, {
                    className: " me-2",
                    to: "/manage_products/view/" + row.pd_ppresendetail_id,
                    children: /*#__PURE__*/ _jsx(Visibility, {
                        style: {
                            color: "rgba(255, 246, 229, 1)",
                            fontSize: 30,
                            borderRadius: 40,
                            background: "rgba(253, 180, 40, 1)",
                            padding: 5
                        }
                    })
                });
            }
        }
    ];
    useEffect(function() {
        if (partnerId) {
            getData();
        }
    }, [
        partnerId
    ]);
    var _useState6 = _sliced_to_array(useState(""), 2), filterText = _useState6[0], setFilterText = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), filteredItems = _useState7[0], setFilteredItems = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), excelData = _useState8[0], setExcelData = _useState8[1];
    useEffect(function() {
        if (filterText && filterText != "" && filterText != null) {
            setFilteredItems(productRow.filter(function(item) {
                return item.pd_ppresendetail_id !== null && item.pd_ppresendetail_status > 1 && (item.PdProduct && item.PdProduct.pd_product_code && item.PdProduct.pd_product_code != null && item.PdProduct.pd_product_code.toUpperCase().includes(filterText.toUpperCase()) || item.PdProduct && item.PdProduct.pd_product_barcode && item.PdProduct.pd_product_barcode != null && item.PdProduct.pd_product_barcode.toUpperCase().includes(filterText.toUpperCase()) || item.PdProduct && item.PdProduct.pd_product_nameth && item.PdProduct.pd_product_nameth != null && item.PdProduct.pd_product_nameth.includes(filterText) || item.PdProduct && item.PdProduct.pd_product_nameen && item.PdProduct.pd_product_nameen != null && item.PdProduct.pd_product_nameen.includes(filterText));
            }));
        } else {
            setFilteredItems(productRow.filter(function(item) {
                return item.pd_ppresendetail_id !== null && item.pd_ppresendetail_status > 1;
            }));
        }
    }, [
        productRow,
        filterText
    ]);
    useEffect(function() {
        if (filteredItems && filteredItems.length > 0) {
            filteredItems.map(function(item, index) {
                if (item.pd_ppresendetail_id && item.pd_ppresendetail_id != "" && item.pd_ppresendetail_id > 0) {
                    setExcelData(function(excelData) {
                        return _to_consumable_array(excelData).concat([
                            {
                                product_no: index + 1,
                                product_code: item.PdProduct.pd_product_code && item.PdProduct.pd_product_code != "" && item.PdProduct.pd_product_code != null ? item.PdProduct.pd_product_code : "-",
                                product_barcode: item.PdProduct.pd_product_barcode && item.PdProduct.pd_product_barcode != "" && item.PdProduct.pd_product_barcode != null ? item.PdProduct.pd_product_barcode : "-",
                                product_name_th: item.PdProduct.pd_product_nameth && item.PdProduct.pd_product_nameth != "" && item.PdProduct.pd_product_nameth != null ? item.PdProduct.pd_product_nameth : "-",
                                product_name_en: item.PdProduct.pd_product_nameen && item.PdProduct.pd_product_nameen != "" && item.PdProduct.pd_product_nameen != null ? item.PdProduct.pd_product_nameen : "-",
                                product_unit: item.PdProduct.SetUnit.set_unit_name && item.PdProduct.SetUnit.set_unit_name != null && item.PdProduct.SetUnit.set_unit_name != "" ? item.PdProduct.SetUnit.set_unit_name : "-",
                                product_price: item.PdProduct.pd_product_price && item.PdProduct.pd_product_price >= 0 ? NumberFormatFloat(item.PdProduct.pd_product_price, 2) : "-",
                                recomment_price: item.PdProduct.pd_product_recommentprice && item.PdProduct.pd_product_recommentprice >= 0 ? NumberFormatFloat(item.PdProduct.pd_product_recommentprice, 2) : "-",
                                product_gp: item.PdProduct.pd_product_gp && item.PdProduct.pd_product_gp != "" && item.PdProduct.pd_product_gp != null ? NumberFormatFloat(item.PdProduct.pd_product_gp, 2) + " %" : "-",
                                status: item.pd_ppresendetail_status && item.pd_ppresendetail_status == 5 ? "รอแก้ไข" : item.pd_ppresendetail_status && item.pd_ppresendetail_status == 4 ? "ไม่อนุมัติ" : item.pd_ppresendetail_status && item.pd_ppresendetail_status == 3 ? "อนุมัติ" : item.pd_ppresendetail_status && item.pd_ppresendetail_status == 2 ? "รออนุมัติ" : "แบบร่าง"
                            }
                        ]);
                    });
                }
            });
        }
    }, [
        filteredItems
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("nav", {
                    "aria-label": "breadcrumb",
                    className: "mt-2",
                    children: /*#__PURE__*/ _jsxs("ol", {
                        className: "breadcrumb fs-16 ps-0 mb-1",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "/manage_products",
                                    className: "tc-7  text-decoration-none",
                                    children: "จัดการสินค้านำเสนอ"
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item active tc-1 ",
                                "aria-current": "page",
                                children: "สร้างลิสต์สินค้า"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "pagezoom fs-24 mb-2",
                    children: "สร้างลิสต์สินค้า"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-4",
                    children: /*#__PURE__*/ _jsx(Formik, {
                        enableReinitialize: true,
                        initialValues: formdata,
                        children: function(param) {
                            var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                            return /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx(Form, {
                                    noValidate: true,
                                    onSubmit: function(e) {
                                        e.preventDefault();
                                        console.log(values);
                                        handleSubmit();
                                    },
                                    children: /*#__PURE__*/ _jsxs("fieldset", {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "ข้อมูลสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl col-md-6",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "รหัสลิสต์"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_ppresentation_code",
                                                                                    className: "form-control",
                                                                                    placeholder: "รหัสลิสต์",
                                                                                    value: values.pd_ppresentation_code,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.pd_ppresentation_code,
                                                                                    disabled: formdisabled
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl col-md-6",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "ชื่อลิสต์",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: "*"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_ppresentation_name",
                                                                                    className: "form-control",
                                                                                    placeholder: "ชื่อลิสต์",
                                                                                    value: values.pd_ppresentation_name,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.pd_ppresentation_name,
                                                                                    disabled: formdisabled
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl col-md-6",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "จำนวนรายการ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_ppresentation_totalproduct",
                                                                                    className: "form-control",
                                                                                    placeholder: "จำนวนรายการ",
                                                                                    value: values.pd_ppresentation_totalproduct,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.pd_ppresentation_totalproduct,
                                                                                    disabled: formdisabled
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl col-md-6",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "วันที่สร้าง"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                                                    inputFormat: "DD/MM/YYYY",
                                                                                    selected: values.pd_ppresentation_credate ? moment(values.pd_ppresentation_credate).toDate() : "",
                                                                                    onChange: function(date) {
                                                                                        if (moment(date).isValid()) {
                                                                                            // console.log(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                                            setFieldValue("pd_ppresentation_credate", moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                                        } else {
                                                                                            setFieldValue("pd_ppresentation_credate", "");
                                                                                        }
                                                                                    },
                                                                                    placeholder: "DD/MM/YYYY",
                                                                                    className: "w-100 datepicker2 ".concat(values.pd_ppresentation_credate ? "" : !!errors.pd_ppresentation_credate ? "is-invalid" : ""),
                                                                                    value: values.pd_ppresentation_credate ? moment(values.pd_ppresentation_credate).format("DD/MM/YYYY") : "",
                                                                                    disabled: formdisabled
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl col-md-6",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "หมายเหตุ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_ppresentation_remark",
                                                                                    className: "form-control",
                                                                                    placeholder: "หมายเหตุ",
                                                                                    value: values.pd_ppresentation_remark,
                                                                                    onChange: handleChange,
                                                                                    isInvalid: !!errors.pd_ppresentation_remark,
                                                                                    disabled: formdisabled
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl col-md-4",
                                                                        children: /*#__PURE__*/ _jsx(Stack, {
                                                                            direction: "row",
                                                                            justifyContent: "flex-end",
                                                                            alignContent: "flex-end",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "px-4 py-1 text-center my-3",
                                                                                style: {
                                                                                    color: values.pd_ppresentation_status == 1 && "rgba(116, 116, 116, 1)" || values.pd_ppresentation_status == 2 && "rgba(253, 180, 40, 1)" || values.pd_ppresentation_status == 3 && "rgba(130, 228, 65, 1)" || values.pd_ppresentation_status == 4 && "rgba(249, 80, 87, 1)",
                                                                                    backgroundColor: values.pd_ppresentation_status == 1 && "rgba(244, 244, 244, 1)" || values.pd_ppresentation_status == 2 && "rgba(255, 246, 229, 1)" || values.pd_ppresentation_status == 3 && "rgba(238, 251, 229, 1)" || values.pd_ppresentation_status == 4 && "rgba(255, 227, 227, 1)",
                                                                                    borderRadius: "20px"
                                                                                },
                                                                                children: values.pd_ppresentation_status == 1 && "ร่างแบบ" || values.pd_ppresentation_status == 2 && "รอตรวจสอบ" || values.pd_ppresentation_status == 3 && "ตรวจสอบแล้ว" || values.pd_ppresentation_status == 4 && "ยกเลิก"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-24 mb-4",
                                                children: "รายการสินค้าส่งนำเสนอ"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "row gx-xl-4 mb-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-8 col-md-6"
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4 col-md-6",
                                                                    children: /*#__PURE__*/ _jsx(Stack, {
                                                                        direction: "horizontal",
                                                                        children: /*#__PURE__*/ _jsx("input", {
                                                                            type: "text",
                                                                            className: "form-control",
                                                                            placeholder: "ค้นหารหัสสินค้า, บาร์โค๊ด, ชื่อสินค้า",
                                                                            onKeyUp: function(e) {
                                                                                return setFilterText(e.target.value);
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx(DataTableLayout, {
                                                            item: filteredItems,
                                                            columns: columns,
                                                            isSelectRows: false,
                                                            PerPage: 10
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            });
                        }
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "card card-st-3 mb-3",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row gx-xl-4",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "col-xl-12 col-md-12 text-end",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    href: "/manage_products",
                                    variant: "outline-secondary",
                                    children: "ย้อนกลับ"
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}
export function ManageProductsView() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(1), 2), tab = _useState[0], setTab = _useState[1];
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState1 = _sliced_to_array(useState("view"), 2), mode = _useState1[0], setMode = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), formdisabled = _useState2[0], setFormdisabled = _useState2[1];
    var partnerId = useParams().partnerId;
    var _useState3 = _sliced_to_array(useState(""), 2), commentBox = _useState3[0], setCommentBox = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState4[0], setIsBoxAlert = _useState4[1];
    var _useState5 = _sliced_to_array(useState(null), 2), brandId = _useState5[0], setBrandId = _useState5[1];
    var _useState6 = _sliced_to_array(useState({}), 2), formdata = _useState6[0], setFormdata = _useState6[1];
    var _useState7 = _sliced_to_array(useState(1), 2), status = _useState7[0], setStatus = _useState7[1];
    var _useState8 = _sliced_to_array(useState(false), 2), loadRow = _useState8[0], setLoadRow = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), pdetailId = _useState9[0], setPdetailId = _useState9[1];
    var _useState10 = _sliced_to_array(useState([
        {
            rowID: nanoid(),
            productRowID: 1,
            productRowBarcode: "",
            productRowUnit: "",
            productRowRate: "",
            productRowContainer: "",
            productRowPresent: "",
            productRowRecommended: "",
            productRowGP: "",
            productRowWeight: "",
            productRowUnitWeight: "",
            productRowUnitWeightName: "",
            productRowWidth: "",
            productRowLong: "",
            productRowHeight: "",
            productRowUnitDimension: ""
        }
    ]), 2), productRow = _useState10[0], setProductRow = _useState10[1];
    var getProductInfoByIdReducer = useAppSelector(function(state) {
        return state.getProductInfoByIdReducer;
    });
    var getProductTypeReducer = useAppSelector(function(state) {
        return state.getProductTypeReducer;
    });
    var getCategoryReducer = useAppSelector(function(state) {
        return state.getCategoryReducer;
    });
    var getSubCategoryReducer = useAppSelector(function(state) {
        return state.getSubCategoryReducer;
    });
    // const getEvidenceTypeReducer = useAppSelector(
    //   (state) => state.getEvidenceTypeReducer
    // );
    var getAllMstUnitReducer = useAppSelector(function(state) {
        return state.getAllMstUnitReducer;
    });
    var getAllMstUnitWeightReducer = useAppSelector(function(state) {
        return state.getAllMstUnitWeightReducer;
    });
    var getAllDimensionReducer = useAppSelector(function(state) {
        return state.getAllDimensionReducer;
    });
    var getAllProductTypeFileReducer = useAppSelector(function(state) {
        return state.getAllProductTypeFileReducer;
    });
    var getAllMstBrandReducer = useAppSelector(function(state) {
        return state.getAllMstBrandReducer;
    });
    var onChangeProductRow = function() {
        var _ref = _async_to_generator(function(action, event, index) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(action === "productRowBarcode")) return [
                            3,
                            2
                        ];
                        productRow[index].productRowBarcode = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 1:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 2;
                    case 2:
                        if (!(action === "productRowUnit")) return [
                            3,
                            4
                        ];
                        productRow[index].productRowUnit = event.value;
                        productRow[index].productRowUnitName = event.label;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 3:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 4;
                    case 4:
                        if (!(action === "productRowRate")) return [
                            3,
                            6
                        ];
                        productRow[index].productRowRate = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 5:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 6;
                    case 6:
                        if (!(action === "productRowContainer")) return [
                            3,
                            8
                        ];
                        productRow[index].productRowContainer = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 7:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 8;
                    case 8:
                        if (!(action === "productRowPresent")) return [
                            3,
                            10
                        ];
                        productRow[index].productRowPresent = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 9:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 10;
                    case 10:
                        if (!(action === "productRowRecommended")) return [
                            3,
                            12
                        ];
                        productRow[index].productRowRecommended = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 11:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 12;
                    case 12:
                        if (!(action === "productRowGP")) return [
                            3,
                            14
                        ];
                        productRow[index].productRowGP = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 13:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 14;
                    case 14:
                        if (!(action === "productRowWeight")) return [
                            3,
                            16
                        ];
                        productRow[index].productRowWeight = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 15:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 16;
                    case 16:
                        if (!(action === "productRowUnitWeight")) return [
                            3,
                            18
                        ];
                        productRow[index].productRowUnitWeight = event.value;
                        productRow[index].productRowUnitWeightName = event.label;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 17:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 18;
                    case 18:
                        if (!(action === "productRowWidth")) return [
                            3,
                            20
                        ];
                        productRow[index].productRowWidth = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 19:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 20;
                    case 20:
                        if (!(action === "productRowLong")) return [
                            3,
                            22
                        ];
                        productRow[index].productRowLong = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 21:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 22;
                    case 22:
                        if (!(action === "productRowHeight")) return [
                            3,
                            24
                        ];
                        productRow[index].productRowHeight = event.target.value;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 23:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 24;
                    case 24:
                        if (!(action === "productRowUnitDimension")) return [
                            3,
                            26
                        ];
                        productRow[index].productRowUnitDimension = event.value;
                        productRow[index].productRowUnitDimensionName = event.label;
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 25:
                        _state.sent();
                        setLoadRow(!loadRow);
                        _state.label = 26;
                    case 26:
                        return [
                            2
                        ];
                }
            });
        });
        return function onChangeProductRow(action, event, index) {
            return _ref.apply(this, arguments);
        };
    }();
    var createCommentProductReducer = useAppSelector(function(state) {
        return state.createCommentProductReducer;
    });
    var _useState11 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState11[0], setModalsuccess = _useState11[1];
    var schema = yup.object().shape({
        product_code: yup.string().required()
    });
    var optionsOffline = [
        {
            value: 1,
            label: "7-11"
        },
        {
            value: 2,
            label: "Big-C"
        },
        {
            value: 3,
            label: "Boots"
        },
        {
            value: 4,
            label: "Tesco"
        },
        {
            value: 5,
            label: "Watson"
        },
        {
            value: 6,
            label: "Tops"
        }
    ];
    var optionsOnline = [
        {
            value: 1,
            label: "Facebook"
        },
        {
            value: 2,
            label: "IG"
        },
        {
            value: 3,
            label: "Shopee"
        },
        {
            value: 4,
            label: "Ttktok"
        }
    ];
    var optionsDistribution = [
        {
            value: 1,
            label: "Amazon"
        },
        {
            value: 2,
            label: "Webi"
        }
    ];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsType = _useState12[0], setOptionsType = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), optionsCate = _useState13[0], setOptionsCate = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), optionsSupCate = _useState14[0], setOptionsSupCate = _useState14[1];
    var optionsTaxRate = [
        {
            value: 0,
            label: "ไม่มี"
        },
        {
            value: 3,
            label: "VAT 3%"
        },
        {
            value: 7,
            label: "VAT 7%"
        },
        {
            value: 10,
            label: "VAT 10%"
        }
    ];
    var _useState15 = _sliced_to_array(useState([]), 2), optionsUnit = _useState15[0], setOptionsUnit = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), optionsUnitWeight = _useState16[0], setOptionsUnitWeight = _useState16[1];
    var _useState17 = _sliced_to_array(useState([]), 2), optionsDimension = _useState17[0], setOptionsDimension = _useState17[1];
    var _useState18 = _sliced_to_array(useState([]), 2), optionsMstBrand = _useState18[0], setOptionsMstBrand = _useState18[1];
    var optionsDocumentProduction = [
        {
            value: 1,
            label: "ใบเบิกวัตถุดิบ"
        },
        {
            value: 2,
            label: "ใบรับสินค้าเข้า"
        }
    ];
    var _useState19 = _sliced_to_array(useState([]), 2), evidenceType = _useState19[0], setEvidenceType = _useState19[1];
    var getData = function() {
        dispatch(getProductInfoById(parseInt(partnerId, 10), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getProductType());
        // dispatch(getEvidenceType());
        dispatch(getAllMstUnit());
        dispatch(getAllMstUnitWeight());
        dispatch(getAllDimension());
        dispatch(getAllProductTypeFile());
        dispatch(getAllMstBrand());
    };
    var _useState20 = _sliced_to_array(useState(false), 2), approveShow = _useState20[0], setApproveShow = _useState20[1];
    var handleApproveShow = function() {
        return setApproveShow(true);
    };
    var handleApproveClose = function() {
        return setApproveShow(false);
    };
    var _useState21 = _sliced_to_array(useState(false), 2), sendEditShow = _useState21[0], setSendEditShow = _useState21[1];
    var handleSendEditShow = function() {
        return setSendEditShow(true);
    };
    var handleSendEditClose = function() {
        return setSendEditShow(false);
    };
    var _useState22 = _sliced_to_array(useState(false), 2), noApproveShow = _useState22[0], setNoApproveShow = _useState22[1];
    var handleNoApproveShow = function() {
        return setNoApproveShow(true);
    };
    var handleNoApproveClose = function() {
        return setNoApproveShow(false);
    };
    var handleBackPage = function() {
        return pdetailId && pdetailId > 0 ? navigate("/manage_products/datalist/" + pdetailId) : navigate("/manage_products");
    };
    var _useState23 = _sliced_to_array(useState([]), 2), chOffline = _useState23[0], setChOffline = _useState23[1];
    var _useState24 = _sliced_to_array(useState([]), 2), chOnLine = _useState24[0], setChOnline = _useState24[1];
    var _useState25 = _sliced_to_array(useState(0), 2), pdTypeId = _useState25[0], setPdTypeId = _useState25[1];
    var _useState26 = _sliced_to_array(useState(0), 2), pdCateId = _useState26[0], setPdCateId = _useState26[1];
    var _useState27 = _sliced_to_array(useState(0), 2), productId = _useState27[0], setProductId = _useState27[1];
    useEffect(function() {
        setIsLoading(getProductInfoByIdReducer.isFetching || getProductTypeReducer.isFetching || getCategoryReducer.isFetching || getSubCategoryReducer.isFetching || createCommentProductReducer.isFetching || getAllMstBrandReducer.isFetching || getAllMstUnitReducer.isFetching || getAllMstUnitWeightReducer.isFetching || getAllDimensionReducer.isFetching || getAllProductTypeFileReducer.isFetching);
        if (getProductTypeReducer.data) {
            getProductTypeReducer.data.data.map(function(ele) {
                return setOptionsType(function(optionsType) {
                    return _to_consumable_array(optionsType).concat([
                        {
                            value: ele.set_producttype_id,
                            label: ele.set_producttype_name + " (" + ele.set_producttype_nameen + ")"
                        }
                    ]);
                });
            });
        }
        if (getCategoryReducer.data) {
            getCategoryReducer.data.data.map(function(ele) {
                return setOptionsCate(function(optionsCate) {
                    return _to_consumable_array(optionsCate).concat([
                        {
                            value: ele.set_productcategory_id,
                            label: ele.set_productcategory_name + " (" + ele.set_productcategory_nameen + ")"
                        }
                    ]);
                });
            });
        }
        if (getSubCategoryReducer.data) {
            var dataSubCate = [];
            getSubCategoryReducer.data.data.map(function(ele) {
                return dataSubCate.push({
                    label: ele.set_productcategorysub_name + " (" + ele.set_productcategorysub_nameen + ")",
                    value: ele.set_productcategorysub_id
                });
            });
            setOptionsSupCate(dataSubCate);
        }
        if (getAllMstBrandReducer.data && !getAllMstBrandReducer.isError) {
            var dataBrandNew = [];
            getAllMstBrandReducer.data.data.map(function(ele) {
                return dataBrandNew.push({
                    label: ele.set_brand_name + " (" + ele.set_brand_nameen + ")",
                    value: ele.set_brand_id
                });
            });
            setOptionsMstBrand(dataBrandNew);
        }
        if (getAllMstUnitReducer.data) {
            var dataUnit = [];
            getAllMstUnitReducer.data.data.map(function(ele) {
                return dataUnit.push({
                    label: ele.set_unit_name,
                    value: ele.set_unit_id
                });
            });
            setOptionsUnit(dataUnit);
        }
        if (getAllMstUnitWeightReducer.data) {
            var dataUnitWeight = [];
            getAllMstUnitWeightReducer.data.data.map(function(ele) {
                return dataUnitWeight.push({
                    label: ele.set_unitweight_name,
                    value: ele.set_unitweight_id
                });
            });
            setOptionsUnitWeight(dataUnitWeight);
        }
        if (getAllDimensionReducer.data) {
            var dataDimension = [];
            getAllDimensionReducer.data.data.map(function(ele) {
                return dataDimension.push({
                    label: ele.set_dimension_name,
                    value: ele.set_dimension_id
                });
            });
            setOptionsDimension(dataDimension);
        }
        if (getAllProductTypeFileReducer.data && !getAllProductTypeFileReducer.isError) {
            var dataEvidence = [];
            getAllProductTypeFileReducer.data.data.map(function(ele) {
                return dataEvidence.push({
                    label: ele.set_productfiletype_name,
                    value: ele.set_productfiletype_id
                });
            });
            setEvidenceType(dataEvidence);
        }
        if (getProductInfoByIdReducer.data && !getProductInfoByIdReducer.isError) {
            var datas = getProductInfoByIdReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            var dataWithReplacements = Object.entries(datas).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            if (datas && datas.pd_product_id && datas.pd_product_id > 0) {
                setProductId(datas.pd_product_id);
            }
            if (datas && datas.pd_ppresendetail_presentationid && datas.pd_ppresendetail_presentationid > 0) {
                setPdetailId(datas.pd_ppresendetail_presentationid);
            }
            if (datas && datas.pd_product_producttypeid && datas.pd_product_producttypeid > 0) {
                setPdTypeId(datas.pd_product_producttypeid);
            }
            if (datas && datas.pd_product_categoryid && datas.pd_product_categoryid > 0) {
                setPdCateId(datas.pd_product_categoryid);
            }
            if (datas && datas.PdPchanneloffline && datas.PdPchanneloffline.length > 0) {
                setChOffline([]);
                datas.PdPchanneloffline.map(function(item, index) {
                    if (item.pd_pchanneloffline_channelofflineid && item.pd_pchanneloffline_channelofflineid != "") {
                        setChOffline(function(chOffline) {
                            return _to_consumable_array(chOffline).concat([
                                {
                                    value: item.pd_pchanneloffline_channelofflineid,
                                    label: item.pd_pchanneloffline_name
                                }
                            ]);
                        });
                    }
                });
            }
            if (datas && datas.PdPchannelonline && datas.PdPchannelonline.length > 0) {
                setChOnline([]);
                datas.PdPchannelonline.map(function(item, index) {
                    if (item.pd_pchannelonline_channelonlineid && item.pd_pchannelonline_channelonlineid != "") {
                        setChOnline(function(chOnLine) {
                            return _to_consumable_array(chOnLine).concat([
                                {
                                    value: item.pd_pchannelonline_channelonlineid,
                                    label: item.pd_pchannelonline_name
                                }
                            ]);
                        });
                    }
                });
            }
            if (datas && datas.PdPdetail && datas.PdPdetail.length > 0) {
                setProductRow(datas.PdPdetail.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        rowID: nanoid(),
                        productRowID: item.pd_pdetail_id,
                        productRowBarcode: item.pd_pdetail_barcode,
                        productRowUnit: item.pd_pdetail_unitid,
                        productRowRate: item.pd_pdetail_ratio,
                        productRowContainer: item.pd_pdetail_continer,
                        productRowPresent: item.pd_pdetail_price,
                        productRowRecommended: item.pd_pdetail_recommentprice,
                        productRowGP: item.pd_pdetail_gp && item.pd_pdetail_gp != "" ? item.pd_pdetail_gp + "%" : "",
                        productRowWeight: JSON.stringify(item.pd_pdetail_weight),
                        productRowUnitWeight: item.SetUnitweight && item.SetUnitweight.set_unitweight_id && item.SetUnitweight.set_unitweight_id > 0 ? item.SetUnitweight.set_unitweight_id : "",
                        productRowUnitWeightName: item.SetUnitweight && item.SetUnitweight.set_unitweight_name && item.SetUnitweight.set_unitweight_name != "" && item.SetUnitweight.set_unitweight_name != null ? item.SetUnitweight.set_unitweight_name : "",
                        productRowWidth: item.pd_pdetail_wide,
                        productRowLong: item.pd_pdetail_long,
                        productRowHeight: item.pd_pdetail_high,
                        productRowUnitDimension: item.pd_pdetail_dimensionid
                    });
                }));
            }
            if (datas && datas.pd_product_brandid && datas.pd_product_brandid > 0) {
                setBrandId(datas.pd_product_brandid);
            }
            setFormdata(dataWithReplacements);
            setFormdisabled(true);
        }
        if (isBoxAlert && createCommentProductReducer.data && !createCommentProductReducer.isError) {
            var updatedData = createCommentProductReducer.data.data;
            dispatch(clearCreateCommentProduct());
            if (isBoxAlert) {
                getData();
                setIsBoxAlert(false);
            }
        }
    }, [
        getProductInfoByIdReducer,
        getProductTypeReducer,
        getCategoryReducer,
        getSubCategoryReducer,
        createCommentProductReducer,
        getAllMstBrandReducer,
        getAllMstUnitReducer,
        getAllMstUnitWeightReducer,
        getAllDimensionReducer,
        getAllProductTypeFileReducer
    ]);
    useEffect(function() {
        if (partnerId) {
            getData();
        }
        if (pdTypeId && pdTypeId > 0) {
            dispatch(getCategory(pdTypeId));
        }
        if (pdTypeId && pdCateId && pdTypeId > 0 && pdCateId > 0) {
            dispatch(getSubCategory(pdTypeId, pdCateId));
        }
    }, [
        partnerId,
        pdTypeId,
        pdCateId
    ]);
    var handleChangeComment = function(e) {
        setCommentBox(e.target.value);
    };
    var handleClickComment = function(val) {
        if (commentBox && productId && commentBox.trim() !== "" && productId > 0) {
            setIsLoading(true);
            var payload = {
                pd_product_id: productId,
                pd_pcomment_detail: commentBox
            };
            dispatch(createCommentProduct(payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            setCommentBox("");
        } else {
            setIsBoxAlert(false);
            setCommentBox("");
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            formdata.pd_product_status != 3 && formdata.pd_product_status != 4 ? /*#__PURE__*/ _jsx("div", {
                className: "card card-st-1 mb-3",
                children: /*#__PURE__*/ _jsxs(Row, {
                    className: "justify-content-md-between",
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            lg: 8
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            xs: 12,
                            lg: "auto",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex gap-2 mb-3 mt-3 mr-4",
                                children: [
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "outline-secondary",
                                        onClick: handleBackPage,
                                        children: "ย้อนกลับ"
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "danger",
                                        onClick: handleNoApproveShow,
                                        children: "ไม่อนุมัติ"
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "warning",
                                        onClick: handleSendEditShow,
                                        children: "ส่งกลับแก้ไข"
                                    }),
                                    /*#__PURE__*/ _jsx(Button, {
                                        variant: "success",
                                        onClick: handleApproveShow,
                                        children: "อนุมัติ"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = formdataPayload.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pair = _step.value;
                            var _pair__name;
                            console.log("".concat(pair[0], ", ").concat((_pair__name = pair[1].name) !== null && _pair__name !== void 0 ? _pair__name : pair[1]));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsx(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            console.log(values);
                            handleSubmit();
                        },
                        children: /*#__PURE__*/ _jsxs("fieldset", {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-3",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "pt-3 px-3",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Row, {
                                                    className: "align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Col, {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "tc-8 fs-18 fw-bold px-3 mb-3",
                                                                children: "ข้อมูลทั่วไป"
                                                            })
                                                        }),
                                                        values.pd_product_status == 4 ? /*#__PURE__*/ _jsx(Col, {
                                                            className: "text-end mb-3",
                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                className: "px-3 py-2 text-center badge fs-16",
                                                                style: {
                                                                    color: "rgba(211, 47, 47, 1)",
                                                                    backgroundColor: "rgba(253, 237, 237, 1)",
                                                                    borderRadius: "20px"
                                                                },
                                                                children: "ไม่อนุมัติ เมื่อวันที่ " + (values.pd_product_updatedate ? moment(values.pd_product_updatedate).format("DD/MM/YYYY") : "-")
                                                            })
                                                        }) : values.pd_product_status == 3 ? /*#__PURE__*/ _jsx(Col, {
                                                            className: "text-end mb-2",
                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                className: "px-3 py-2 text-center badge fs-16",
                                                                style: {
                                                                    color: "rgba(114, 225, 40, 0.87)",
                                                                    backgroundColor: "rgba(238, 251, 229, 1)",
                                                                    borderRadius: "20px"
                                                                },
                                                                children: "อนุมัติแล้ว เมื่อวันที่ " + (values.pd_product_approvedate ? moment(values.pd_product_approvedate).format("DD/MM/YYYY") : "-")
                                                            })
                                                        }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "row gx-xl-4",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "รหัสสินค้า",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger ms-1",
                                                                                children: "*"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "pd_product_code",
                                                                        className: "form-control",
                                                                        placeholder: "รหัสสินค้า",
                                                                        value: filterTextAndNum(values.pd_product_code),
                                                                        onChange: handleChange,
                                                                        isInvalid: !!errors.pd_product_code,
                                                                        disabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "Barcode",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger ms-1",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "pd_product_barcode",
                                                                        className: "form-control",
                                                                        placeholder: "Barcode",
                                                                        value: filterTextAndNum(values.pd_product_barcode),
                                                                        onChange: handleChange,
                                                                        isInvalid: !!errors.pd_product_barcode,
                                                                        disabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "ชื่อสินค้าภาษาไทย ( TH )",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger ms-1",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "pd_product_nameth",
                                                                        className: "form-control",
                                                                        placeholder: "กรอกชื่อสินค้าภาษาไทย ( TH )",
                                                                        value: filterTextAndNum(values.pd_product_nameth),
                                                                        onChange: handleChange,
                                                                        isInvalid: !!errors.pd_product_nameth,
                                                                        disabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "ชื่อสินค้าภาษาอังกฤษ",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger ms-1",
                                                                                children: " *"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "pd_product_nameen",
                                                                        className: "form-control",
                                                                        placeholder: "กรอกชื่อสินค้าภาษาอังกฤษ",
                                                                        value: filterTextAndNum(values.pd_product_nameen),
                                                                        onChange: handleChange,
                                                                        isInvalid: !!errors.pd_product_nameen,
                                                                        disabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-3 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "ช่องทางจำหน่ายออฟไลน์"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                        className: "w-100 select-st-1 select-multi",
                                                                        name: "product_offline",
                                                                        as: "select",
                                                                        isMulti: true,
                                                                        options: optionsOffline,
                                                                        onChange: function(e) {
                                                                            setFieldValue("product_offline", e);
                                                                        },
                                                                        placeholder: "เลือกช่องทางจำหน่ายออฟไลน์",
                                                                        value: chOffline,
                                                                        isDisabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-3 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "ช่องทางจำหน่ายออนไลน์"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                        className: "w-100 select-st-1 select-multi",
                                                                        name: "product_online",
                                                                        as: "select",
                                                                        isMulti: true,
                                                                        options: optionsOnline,
                                                                        onChange: function(e) {
                                                                            setFieldValue("product_online", e);
                                                                        },
                                                                        placeholder: "เลือกช่องทางจำหน่ายออนไลน์",
                                                                        value: chOnLine,
                                                                        isDisabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-3 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "ช่องทางจำหน่ายอื่นๆ"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "pd_product_channelother",
                                                                        className: "form-control",
                                                                        placeholder: "กรอกช่องทางจำหน่ายอื่นๆ",
                                                                        value: filterTextAndNum(values.pd_product_channelother),
                                                                        onChange: handleChange,
                                                                        isInvalid: !!errors.pd_product_channelother,
                                                                        disabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "วันหมดอายุ"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "pd_product_pddate",
                                                                        className: "form-control",
                                                                        placeholder: "วันที่หมดอายุ",
                                                                        value: values.pd_product_pddate != null && values.pd_product_pddate != "" && values.pd_product_pddate != "null" ? moment(values.pd_product_pddate).format("DD/MM/YYYY") : "-",
                                                                        onChange: handleChange,
                                                                        disabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "อายุสินค้า ( วัน )"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "pd_product_dayexpire",
                                                                        className: "form-control",
                                                                        placeholder: "อายุสินค้า ( วัน )",
                                                                        value: values.pd_product_pddate != null && values.pd_product_pddate != "" && values.pd_product_pddate != "null" ? moment(values.pd_product_pddate).add({
                                                                            days: 1
                                                                        }).diff(moment(), "days") : "-",
                                                                        onChange: handleChange,
                                                                        disabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-3",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "pt-3 px-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tc-8  fs-18 fw-bold px-3 mb-3",
                                                    children: "ข้อมูลสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "row gx-xl-4",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "form-st-3 sm pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ประเภทสินค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "pd_product_producttypeid",
                                                                            onChange: function(e) {
                                                                                setFieldValue("pd_product_producttypeid", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1",
                                                                            options: optionsType,
                                                                            placeholder: "เลือกประเภทสินค้า",
                                                                            value: optionsType.filter(function(item) {
                                                                                return item.value === values.pd_product_producttypeid;
                                                                            }),
                                                                            isDisabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "form-st-3 sm pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "หมวดหมู่หลัก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "pd_product_categoryid",
                                                                            onChange: function(e) {
                                                                                setFieldValue("pd_product_categoryid", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1",
                                                                            options: optionsCate,
                                                                            placeholder: "เลือกหมวดหมู่หลัก",
                                                                            value: optionsCate.filter(function(item) {
                                                                                return item.value === values.pd_product_categoryid;
                                                                            }),
                                                                            isDisabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "form-st-3 sm pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "หมวดหมู่ย่อย"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "pd_product_categorysubid",
                                                                            onChange: function(e) {
                                                                                setFieldValue("pd_product_categorysubid", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1",
                                                                            options: optionsSupCate,
                                                                            placeholder: "เลือกหมวดหมู่ย่อย",
                                                                            value: optionsSupCate.filter(function(item) {
                                                                                return item.value === values.pd_product_categorysubid;
                                                                            }),
                                                                            isDisabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-6 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "ยี่ห้อ (แบรนด์)",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger ms-1",
                                                                                children: "*"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                        as: "select",
                                                                        name: "pd_product_brandid",
                                                                        onChange: function(e) {
                                                                            setFieldValue("pd_product_brandid", e.value);
                                                                            setBrandId(e.value);
                                                                        },
                                                                        className: "w-100 select-st-1",
                                                                        options: optionsMstBrand,
                                                                        placeholder: "เลือกยี่ห้อ (แบรนด์)",
                                                                        value: optionsMstBrand.filter(function(item) {
                                                                            return item.value === values.pd_product_brandid;
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-12 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "รายละเอียดสินค้า"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        as: "textarea",
                                                                        rows: 3,
                                                                        name: "pd_product_detail",
                                                                        value: filterTextAndNum(values.pd_product_detail),
                                                                        onChange: handleChange,
                                                                        disabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-3",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "pt-3 px-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tc-8  fs-18 fw-bold px-3 mb-3",
                                                    children: "กำหนดราคานำเสนอ"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "row gx-xl-4",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "col-xl-3 col-md-12",
                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                            className: "mb-0 form-st-3 pb-0",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "form-st-3 sm pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: [
                                                                            "อัตราภาษีขาย",
                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                className: "text-danger ms-1",
                                                                                children: "*"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                        as: "select",
                                                                        name: "pd_product_vat",
                                                                        onChange: function(e) {
                                                                            setFieldValue("pd_product_vat", e.value);
                                                                        },
                                                                        className: "w-100 select-st-1",
                                                                        options: optionsTaxRate,
                                                                        placeholder: "เลือกอัตราภาษีขาย",
                                                                        value: optionsTaxRate.filter(function(item) {
                                                                            return item.value === values.pd_product_vat;
                                                                        }),
                                                                        isDisabled: partnerId ? true : false
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("hr", {
                                                    className: "my-2",
                                                    style: {
                                                        opacity: 0.1
                                                    }
                                                }),
                                                productRow.map(function(ele, i) {
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-2",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2 col-md-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "Barcode"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "productRowBarcode",
                                                                            className: "form-control",
                                                                            placeholder: "Barcode",
                                                                            value: filterTextAndNum(ele.productRowBarcode),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowBarcode", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl col-md",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3 sm pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "หน่วย"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "productRowUnit",
                                                                                className: "w-100 select-st-1",
                                                                                options: optionsUnit,
                                                                                placeholder: "เลือกหน่วย",
                                                                                value: optionsUnit.filter(function(item) {
                                                                                    return item.value === ele.productRowUnit;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    return onChangeProductRow("productRowUnit", e, i);
                                                                                },
                                                                                isDisabled: partnerId ? true : false
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl col-md",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อัตตราส่วน"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "number",
                                                                            name: "productRowRate",
                                                                            className: "form-control",
                                                                            placeholder: "อัตตราส่วน",
                                                                            value: filterTextAndNum(ele.productRowRate, 1),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowRate", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl col-md",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "Container"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "productRowContainer",
                                                                            className: "form-control",
                                                                            placeholder: "Container",
                                                                            value: filterTextAndNum(ele.productRowContainer),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowContainer", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl col-md",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ราคานำเสนอ",
                                                                                ele.productRowID == 1 && /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-danger ms-1",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "number",
                                                                            name: "productRowPresent",
                                                                            className: "form-control",
                                                                            placeholder: "ราคานำเสนอ",
                                                                            value: filterTextAndNum(ele.productRowPresent, 2),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowPresent", e, i);
                                                                            },
                                                                            style: {
                                                                                background: "#E4F5FF"
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl col-md",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ราคาแนะนำขาย",
                                                                                ele.productRowID == 1 && /*#__PURE__*/ _jsx("span", {
                                                                                    className: "text-danger ms-1",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "number",
                                                                            name: "productRowRecommended",
                                                                            className: "form-control",
                                                                            placeholder: "ราคาแนะนำขาย",
                                                                            value: filterTextAndNum(ele.productRowRecommended, 2),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowRecommended", e, i);
                                                                            },
                                                                            style: {
                                                                                background: "#2DC76D24"
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-1 col-md-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "GP"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "productRowGP",
                                                                            className: "form-control",
                                                                            placeholder: "GP",
                                                                            value: filterTextAndNum("".concat(ele.productRowGP)),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowGP", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, i);
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-3",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "pt-3 px-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tc-8  fs-18 fw-bold px-3 mb-3",
                                                    children: "ข้อมูลเฉพาะสินค้า"
                                                }),
                                                productRow.map(function(ele, i) {
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-10",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "Barcode"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "productRowBarcode",
                                                                            className: "form-control",
                                                                            placeholder: "Barcode",
                                                                            value: filterTextAndNum(ele.productRowBarcode),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowBarcode", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2 col-md-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "หน่วย"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "productRowUnit",
                                                                            className: "w-100 select-st-1 disabled",
                                                                            options: optionsUnit,
                                                                            placeholder: "เลือกหน่วย",
                                                                            value: optionsUnit.filter(function(item) {
                                                                                return item.value === ele.productRowUnit;
                                                                            }),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowUnit", e, i);
                                                                            },
                                                                            isDisabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4 col-md-10",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "น้ำหนักสินค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "productRowWeight",
                                                                            className: "form-control",
                                                                            placeholder: "น้ำหนักสินค้า",
                                                                            value: filterTextAndNum(ele.productRowWeight),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowWeight", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-2 col-md-2",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "หน่วยน้ำหนัก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "productRowUnitWeight",
                                                                            className: "w-100 select-st-1 disabled",
                                                                            options: optionsUnitWeight,
                                                                            placeholder: "เลือกหน่วย",
                                                                            value: optionsUnitWeight.filter(function(item) {
                                                                                return item.value === ele.productRowUnitWeight;
                                                                            }),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowUnitWeight", e, i);
                                                                            },
                                                                            isDisabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ความกว้าง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "productRowWidth",
                                                                            className: "form-control",
                                                                            placeholder: "ความกว้าง",
                                                                            value: filterTextAndNum(ele.productRowWidth, 2),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowWidth", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ความยาว"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "productRowLong",
                                                                            className: "form-control",
                                                                            placeholder: "ความยาว",
                                                                            value: filterTextAndNum(ele.productRowLong, 2),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowLong", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ความสูง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "productRowHeight",
                                                                            className: "form-control",
                                                                            placeholder: "ความสูง",
                                                                            value: filterTextAndNum(ele.productRowHeight, 2),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowHeight", e, i);
                                                                            },
                                                                            disabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "หน่วย Dimension"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "productRowUnitDimension",
                                                                            className: "w-100 select-st-1 disabled",
                                                                            options: optionsDimension,
                                                                            placeholder: "เลือกหน่วย Dimension",
                                                                            value: optionsDimension.filter(function(item) {
                                                                                return item.value === ele.productRowUnitDimension;
                                                                            }),
                                                                            onChange: function(e) {
                                                                                return onChangeProductRow("productRowUnitDimension", e, i);
                                                                            },
                                                                            isDisabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("hr", {
                                                                className: "my-2",
                                                                style: {
                                                                    opacity: 0.1
                                                                }
                                                            })
                                                        ]
                                                    }, i);
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-3",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "pt-3 px-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tc-8  fs-18 fw-bold px-3 mb-3",
                                                    children: "เอกสารมาตราฐานการผลิต"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "row gx-xl-4",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "col-12",
                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                            className: "mb-2 form-st-3 pb-1",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                    className: "mb-1",
                                                                    children: [
                                                                        "เลขที่ใบอนุญาต",
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-danger ms-1",
                                                                            children: " *"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                    type: "text",
                                                                    name: "pd_product_evidencenumber",
                                                                    className: "form-control",
                                                                    placeholder: "เลขที่ใบอนุญาต",
                                                                    value: filterTextAndNum(values.pd_product_evidencenumber),
                                                                    onChange: handleChange,
                                                                    isInvalid: !!errors.pd_product_evidencenumber,
                                                                    disabled: partnerId ? true : false
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                values.PdPfile && values.PdPfile.length > 0 ? values.PdPfile.map(function(item, index) {
                                                    return /*#__PURE__*/ _jsxs(Row, {
                                                        className: "align-items-center mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Col, {
                                                                xs: 2,
                                                                md: 2,
                                                                lg: 2,
                                                                xl: "auto",
                                                                children: /*#__PURE__*/ _jsxs("p", {
                                                                    className: "tc-5 fs-18 mb-2 fw-bold ",
                                                                    children: [
                                                                        index + 1,
                                                                        "."
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx(Col, {
                                                                xs: 10,
                                                                md: 5,
                                                                lg: 4,
                                                                xl: 3,
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เอกสาร"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "pd_pfile_typeid",
                                                                            onChange: function(e) {
                                                                                setFieldValue("pd_pfile_typeid", e);
                                                                            },
                                                                            className: "w-100 select-st-1 ".concat(formdisabled ? "pointer-events-none" : "", " ").concat(item.pd_pfile_typeid ? "" : !!errors.pd_pfile_typeid ? "is-invalid" : ""),
                                                                            options: evidenceType,
                                                                            placeholder: "เลือกประเภทสินค้า",
                                                                            value: evidenceType.filter(function(item2) {
                                                                                return item2.value === item.pd_pfile_typeid;
                                                                            }),
                                                                            isInvalid: !!errors.pd_pfile_typeid,
                                                                            isDisabled: partnerId ? true : false
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx(Col, {
                                                                xs: 12,
                                                                md: 5,
                                                                lg: 4,
                                                                xl: 4,
                                                                children: item.pd_pfile_name != null && item.pd_pfile_name != "" ? /*#__PURE__*/ _jsx(DownloadFile, {
                                                                    urlPath: item.pd_pfile_name,
                                                                    fileName: item.pd_pfile_namefile,
                                                                    showIcon: true
                                                                }) : /*#__PURE__*/ _jsx("button", {
                                                                    type: "button",
                                                                    className: "btn btn-upload-file",
                                                                    disabled: partnerId ? true : false,
                                                                    onClick: function(e) {},
                                                                    children: "อัปโหลดไฟล์"
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                                                /*#__PURE__*/ _jsx(Row, {
                                                    className: "align-items-center mb-3",
                                                    children: /*#__PURE__*/ _jsx(Col, {
                                                        xs: 12,
                                                        children: /*#__PURE__*/ _jsx(Button, {
                                                            variant: "secondary",
                                                            onClick: function() {},
                                                            className: "btn-st-3",
                                                            disabled: partnerId ? true : false,
                                                            children: "เพิ่มเอกสาร"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-3",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "pt-3 px-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tc-8  fs-18 fw-bold px-3 mb-3",
                                                    children: "รูปภาพสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "row gx-xl-4",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-2 col-md-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-16 px-3",
                                                                children: [
                                                                    "ภาพสินค้ามาตราฐาน",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "text-danger ms-1",
                                                                        children: "*"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-10 col-md-9",
                                                            children: /*#__PURE__*/ _jsx(Stack, {
                                                                direction: "row",
                                                                spacing: {
                                                                    xs: 1,
                                                                    sm: 2
                                                                },
                                                                useFlexGap: true,
                                                                sx: {
                                                                    justifyContent: "flex-start",
                                                                    alignItems: "center",
                                                                    flexWrap: "wrap"
                                                                },
                                                                children: values.pd_product_image && values.pd_product_image != "" && values.pd_product_image != null ? /*#__PURE__*/ _jsx("div", {
                                                                    className: "mb-2",
                                                                    style: {
                                                                        alignContent: "center",
                                                                        border: "1px dashed rgba(203, 208, 220, 1)",
                                                                        borderRadius: 10,
                                                                        height: 200,
                                                                        width: 200
                                                                    },
                                                                    children: /*#__PURE__*/ _jsx("img", {
                                                                        src: values.pd_product_image,
                                                                        style: {
                                                                            maxHeight: "100%",
                                                                            margin: "0 auto"
                                                                        }
                                                                    })
                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                    className: "mb-2",
                                                                    style: {
                                                                        alignContent: "center",
                                                                        border: "1px dashed rgba(203, 208, 220, 1)",
                                                                        borderRadius: 10,
                                                                        height: 200,
                                                                        width: 200
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-12"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "offset-xl-2 col-xl-4 offset-md-3 col-md-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "fs-12",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "pr-1",
                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                style: {
                                                                                    fontSize: 5
                                                                                }
                                                                            })
                                                                        }),
                                                                        "อัปโหลดรูปภาพพื้นหลังขาวเท่านั้น"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "fs-12",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "pr-1",
                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                style: {
                                                                                    fontSize: 5
                                                                                }
                                                                            })
                                                                        }),
                                                                        "อัปโหลดรูปภาพขนาดไฟล์ไม่เกิน 2 MB"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "fs-12",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "pr-1",
                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                style: {
                                                                                    fontSize: 5
                                                                                }
                                                                            })
                                                                        }),
                                                                        "อัปโหลดรูปภาพขนาดภาพไม่เกิน 1000x1000"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "fs-12",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "pr-1",
                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                style: {
                                                                                    fontSize: 5
                                                                                }
                                                                            })
                                                                        }),
                                                                        "รูปสินค้าจะแสดงผลหน้าผลการค้นหา และหน้าสินค้าแนะนำ"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "row gx-xl-4 mt-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-2 col-md-3",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "fs-16 px-3",
                                                                children: "แกลลอรี่"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-10 col-md-9",
                                                            children: /*#__PURE__*/ _jsx(Stack, {
                                                                direction: "row",
                                                                spacing: {
                                                                    xs: 1,
                                                                    sm: 2
                                                                },
                                                                useFlexGap: true,
                                                                sx: {
                                                                    justifyContent: "flex-start",
                                                                    alignItems: "center",
                                                                    flexWrap: "wrap"
                                                                },
                                                                children: values.PdPimage && values.PdPimage.length > 0 ? values.PdPimage.map(function(ele, i) {
                                                                    return /*#__PURE__*/ _jsx("div", {
                                                                        className: "mb-2",
                                                                        style: {
                                                                            alignContent: "center",
                                                                            border: "1px dashed rgba(203, 208, 220, 1)",
                                                                            borderRadius: 10,
                                                                            height: 200,
                                                                            width: 200
                                                                        },
                                                                        children: ele.pd_pimage_name && ele.pd_pimage_name != "" && ele.pd_pimage_name != null ? /*#__PURE__*/ _jsx("img", {
                                                                            src: ele.pd_pimage_name,
                                                                            style: {
                                                                                maxHeight: "100%",
                                                                                margin: "0 auto"
                                                                            }
                                                                        }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                                                    });
                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                    className: "mb-2",
                                                                    style: {
                                                                        alignContent: "center",
                                                                        border: "1px dashed rgba(203, 208, 220, 1)",
                                                                        borderRadius: 10,
                                                                        height: 200,
                                                                        width: 200
                                                                    }
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "row gx-xl-4 mt-3",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "offset-xl-2 col-xl-4 offset-md-3 col-md-5",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "pr-1",
                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                            style: {
                                                                                fontSize: 5
                                                                            }
                                                                        })
                                                                    }),
                                                                    "อัปโหลดรูปภาพขนาดไฟล์ไม่เกิน 2 MB"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "pr-1",
                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                            style: {
                                                                                fontSize: 5
                                                                            }
                                                                        })
                                                                    }),
                                                                    "อัปโหลดรูปภาพขนาดภาพไม่เกิน 1000x1000"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-12",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "pr-1",
                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                            style: {
                                                                                fontSize: 5
                                                                            }
                                                                        })
                                                                    }),
                                                                    "รูปสินค้าจะแสดงผลหน้าผลการค้นหา และหน้าสินค้าแนะนำ"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    });
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-3 mb-3",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "pt-3",
                        children: [
                            formdata.PdPcomment && formdata.PdPcomment.length > 0 ? formdata.PdPcomment.map(function(item, index) {
                                return item.pd_pcomment_memid && item.pd_pcomment_memid > 0 ? /*#__PURE__*/ _jsxs(Row, {
                                    className: "gx-xl-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 3,
                                            md: 1,
                                            className: "px-2",
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                className: "ms-auto",
                                                src: "/images/Avatar.png",
                                                roundedCircle: true,
                                                style: {
                                                    width: 50,
                                                    border: "4px solid #107BEF",
                                                    borderRadius: 30
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 9,
                                            md: 10,
                                            className: "px-2",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-st-1 p-3",
                                                style: {
                                                    background: "#F6E1E3"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Stack, {
                                                        direction: "row",
                                                        spacing: {
                                                            xs: 1,
                                                            sm: 3
                                                        },
                                                        alignItems: "center",
                                                        useFlexGap: true,
                                                        flexWrap: "wrap",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "fw-6 fs-18",
                                                                children: item.pd_pcomment_memid && item.pd_pcomment_memid != "" && item.pd_pcomment_memid != null ? "Partner_" + item.pd_pcomment_memid : "ไม่ระบุชื่อ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "tc-12 ms-auto",
                                                                children: item.pd_pcomment_issuedate && item.pd_pcomment_issuedate != "" && item.pd_pcomment_issuedate != null ? moment(item.pd_pcomment_issuedate).locale("th").format("D MMMM y H:mm") : "ไม่ระบุ"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16 mt-1",
                                                        children: item.pd_pcomment_detail && item.pd_pcomment_detail != "" && item.pd_pcomment_detail != null ? item.pd_pcomment_detail : "-"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, index) : /*#__PURE__*/ _jsxs(Row, {
                                    className: "gx-xl-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 9,
                                            md: {
                                                span: 10,
                                                offset: 1
                                            },
                                            className: "px-2",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-st-1 p-3",
                                                style: {
                                                    background: "#F6E1E3"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Stack, {
                                                        direction: "row",
                                                        spacing: {
                                                            xs: 1,
                                                            sm: 3
                                                        },
                                                        alignItems: "center",
                                                        useFlexGap: true,
                                                        flexWrap: "wrap",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "fw-6 fs-18",
                                                                children: item.pd_pcomment_userid && item.pd_pcomment_userid != "" && item.pd_pcomment_userid != null ? "Admin_" + item.pd_pcomment_userid : "SYSTEM"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "tc-12 ms-auto",
                                                                children: item.pd_pcomment_issuedate && item.pd_pcomment_issuedate != "" && item.pd_pcomment_issuedate != null ? moment(item.pd_pcomment_issuedate).locale("th").format("D MMMM y H:mm") : "ไม่ระบุ"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16 mt-1",
                                                        children: item.pd_pcomment_detail && item.pd_pcomment_detail != "" && item.pd_pcomment_detail != null ? item.pd_pcomment_detail : "-"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 3,
                                            md: 1,
                                            className: "px-2",
                                            children: item.pd_pcomment_userid && item.pd_pcomment_userid > 0 ? /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/avatar_admin.png",
                                                roundedCircle: true,
                                                style: {
                                                    width: 50,
                                                    border: "4px solid #107BEF",
                                                    borderRadius: 30
                                                }
                                            }) : /*#__PURE__*/ _jsx(Avatar, {
                                                sx: {
                                                    bgcolor: "rgba(244,64,54,1)",
                                                    width: 50,
                                                    height: 50
                                                },
                                                children: "S"
                                            })
                                        })
                                    ]
                                }, index);
                            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "gx-xl-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 2,
                                        md: 1,
                                        className: "pr-2",
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "row",
                                            justifyContent: "flex-end",
                                            spacing: 2,
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/avatar_admin.png",
                                                roundedCircle: true,
                                                style: {
                                                    width: 50,
                                                    border: "4px solid #107BEF",
                                                    borderRadius: 30
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 10,
                                        md: 11,
                                        className: "pl-0",
                                        children: /*#__PURE__*/ _jsxs(InputGroup, {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    placeholder: "เพิ่มคอมเมนต์",
                                                    "aria-label": "Recipient's username",
                                                    "aria-describedby": "basic-addon2",
                                                    onChange: handleChangeComment,
                                                    value: commentBox
                                                }),
                                                /*#__PURE__*/ _jsx(InputGroup.Text, {
                                                    id: "basic-addon2",
                                                    children: /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        className: "btn-dg fs-16",
                                                        onClick: handleClickComment,
                                                        children: "คอมเมนต์"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ApproveModal, {
                show: approveShow,
                onHide: handleApproveClose,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                brandId: brandId,
                pdetailId: pdetailId
            }),
            /*#__PURE__*/ _jsx(SendEditModal, {
                show: sendEditShow,
                onHide: handleSendEditClose,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                brandId: brandId,
                pdetailId: pdetailId
            }),
            /*#__PURE__*/ _jsx(NoApproveModal, {
                show: noApproveShow,
                onHide: handleNoApproveClose,
                modalsuccess: modalsuccess,
                setModalsuccess: setModalsuccess,
                brandId: brandId,
                pdetailId: pdetailId
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
function ApproveModal(_param) {
    var modalsuccess = _param.modalsuccess, setModalsuccess = _param.setModalsuccess, props = _object_without_properties(_param, [
        "modalsuccess",
        "setModalsuccess"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), isBoxAlert = _useState[0], setIsBoxAlert = _useState[1];
    var brandId = props.brandId && props.brandId > 0 ? props.brandId : null;
    var pdetailId = props.pdetailId && props.pdetailId > 0 ? props.pdetailId : null;
    var updateStatusProductReducer = useAppSelector(function(state) {
        return state.updateStatusProductReducer;
    });
    var handleChange = function(e) {};
    var handleClick = function(val) {
        if (brandId && brandId != "" && brandId != null && brandId != "null" && brandId > 0) {
            setIsLoading(true);
            var payload = {
                status: 3,
                comment: "อนุมัติสินค้านำเสนอ",
                brandid: brandId
            };
            dispatch(updateStatusProduct(partnerId, payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setIsBoxAlert(true);
            props.onHide();
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณาเลือกยี่ห้อ (แบรนด์)"
            }));
            setIsBoxAlert(false);
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusProductReducer.isFetching);
        if (updateStatusProductReducer.data && !updateStatusProductReducer.isError) {
            var updatedData = updateStatusProductReducer.data.data;
            dispatch(clearUpdateStatusProduct());
            if (isBoxAlert) {
                setModalsuccess(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "อนุมัติเรียบร้อย",
                        direction: pdetailId && pdetailId > 0 ? "/manage_products/datalist/".concat(pdetailId) : "/manage_products"
                    });
                });
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusProductReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "อนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsxs(Badge, {
                    bg: "danger-light",
                    text: "dark",
                    children: [
                        /*#__PURE__*/ _jsx(InfoIcon, {
                            sx: {
                                color: "#B00412"
                            },
                            className: "mr-2"
                        }),
                        "คุณต้องการที่จะอนุมัติสินค้านำเสนอนี้หรือไม่"
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function SendEditModal(_param) {
    var modalsuccess = _param.modalsuccess, setModalsuccess = _param.setModalsuccess, props = _object_without_properties(_param, [
        "modalsuccess",
        "setModalsuccess"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), remark = _useState[0], setRemark = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState1[0], setIsBoxAlert = _useState1[1];
    var brandId = props.brandId && props.brandId > 0 ? props.brandId : null;
    var pdetailId = props.pdetailId && props.pdetailId > 0 ? props.pdetailId : null;
    var updateStatusProductReducer = useAppSelector(function(state) {
        return state.updateStatusProductReducer;
    });
    var handleChange = function(e) {
        setRemark(e.target.value);
    };
    var handleClick = function() {
        if (remark && remark.trim() !== "") {
            if (brandId && brandId != "" && brandId != null && brandId != "null" && brandId > 0) {
                setIsLoading(true);
                var payload = {
                    status: 5,
                    comment: remark,
                    brandid: brandId
                };
                dispatch(updateStatusProduct(partnerId, payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
                setIsBoxAlert(true);
                setRemark("");
                props.onHide();
            } else {
                setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                    visible: true,
                    subTitle: "รหัส 201",
                    navigateDirection: undefined,
                    title: "กรุณาเลือกยี่ห้อ (แบรนด์)"
                }));
                setIsBoxAlert(false);
                setRemark("");
                props.onHide();
            }
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเหตุผลการแก้ไข"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusProductReducer.isFetching);
        if (updateStatusProductReducer.data && !updateStatusProductReducer.isError) {
            var updatedData = updateStatusProductReducer.data.data;
            dispatch(clearUpdateStatusProduct());
            if (isBoxAlert) {
                setModalsuccess(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "ส่งกลับไปให้แก้ไขเรียบร้อย",
                        direction: pdetailId && pdetailId > 0 ? "/manage_products/datalist/".concat(pdetailId) : "/manage_products"
                    });
                });
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusProductReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ส่งกลับไปแก้ไขอนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    className: "align-items-center mt-3",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการแก้ไข ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-red-gb",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "remark_partner_set",
                                    placeholder: "กรอกคำอธิบาย",
                                    style: {
                                        resize: "none"
                                    },
                                    onChange: handleChange
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function NoApproveModal(_param) {
    var modalsuccess = _param.modalsuccess, setModalsuccess = _param.setModalsuccess, props = _object_without_properties(_param, [
        "modalsuccess",
        "setModalsuccess"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var partnerId = useParams().partnerId;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), remark = _useState[0], setRemark = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isBoxAlert = _useState1[0], setIsBoxAlert = _useState1[1];
    var brandId = props.brandId && props.brandId > 0 ? props.brandId : null;
    var pdetailId = props.pdetailId && props.pdetailId > 0 ? props.pdetailId : null;
    var updateStatusProductReducer = useAppSelector(function(state) {
        return state.updateStatusProductReducer;
    });
    var handleChange = function(e) {
        setRemark(e.target.value);
    };
    var handleClick = function() {
        if (remark && remark.trim() !== "") {
            if (brandId && brandId != "" && brandId != null && brandId != "null" && brandId > 0) {
                setIsLoading(true);
                var payload = {
                    status: 4,
                    comment: remark,
                    brandid: brandId
                };
                dispatch(updateStatusProduct(partnerId, payload, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
                setIsBoxAlert(true);
                setRemark("");
                props.onHide();
            } else {
                setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                    visible: true,
                    subTitle: "รหัส 201",
                    navigateDirection: undefined,
                    title: "กรุณาเลือกยี่ห้อ (แบรนด์)"
                }));
                setIsBoxAlert(false);
                setRemark("");
                props.onHide();
            }
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "กรุณากรอกเหตุผลการไม่อนุมัติ"
            }));
            props.onHide();
        }
    };
    var handleClose = function() {
        return props.onHide();
    };
    useEffect(function() {
        setIsLoading(updateStatusProductReducer.isFetching);
        if (updateStatusProductReducer.data && !updateStatusProductReducer.isError) {
            var updatedData = updateStatusProductReducer.data.data;
            dispatch(clearUpdateStatusProduct());
            if (isBoxAlert) {
                setModalsuccess(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        visible: true,
                        textsuccess: "ไม่อนุมัติเรียบร้อย",
                        direction: pdetailId && pdetailId > 0 ? "/manage_products/datalist/".concat(pdetailId) : "/manage_products"
                    });
                });
                setIsBoxAlert(false);
            }
        }
    }, [
        updateStatusProductReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        backdrop: "static",
        keyboard: false,
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: "ไม่อนุมัติ"
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx(Row, {
                    className: "align-items-center mt-3",
                    children: /*#__PURE__*/ _jsx(Col, {
                        xs: 12,
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsxs(Form.Label, {
                                    className: "mb-1",
                                    children: [
                                        "เหตุผลการไม่อนุมัติ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "span-red-gb",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    as: "textarea",
                                    rows: 3,
                                    name: "remark_noapprove",
                                    placeholder: "กรอกคำอธิบาย",
                                    style: {
                                        resize: "none"
                                    },
                                    onChange: handleChange
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function filterTextAndNum(val) {
    var tyS = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (val && tyS == 2 && val >= 0) {
        return NumberFormatFloat(val, 2);
    } else if (val && tyS == 1 && val >= 0) {
        return parseInt(val, 10);
    } else if (tyS <= 0 && val != "" && val != null && val != "null") {
        return val.trim();
    } else {
        return "";
    }
}
